//eslint-disable-next-line
export default {
    title: 'light',

    colors: {
        primary: '#000229',
        secondary: '#ffffff',
        tertiary: '#FFB422',

        white: '#000',
        black: '#fff',
        gray: '#C7C7C7',

        success: '#03bb85',
        info: '#000229',
        warning: '#0013FF',

        cardWhite: '#ffffff'
    }
};